// Calculation types enum
export enum CalculationType {
  HYBRID_SOLUTION = 'Hybrid Solution',
  CONVENTIONAL_SOLUTION = 'Conventional Solution',
}

// Rental source types enum
export enum RentalSource {
  CATALOG = 'catalog',
  MANUAL = 'manual',
  NONE = 'none'
}

// Time options for working hours (00:00 to 23:00)
export const timeOptions = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}:00`);

// Genset KVA options
export const gensetKvaOptions = [10, 20, 30, 50, 75, 100, 150, 200, 250, 300, 400, 500, 750, 1000];

// Genset count options
export const gensetCountOptions = Array.from({ length: 20 }, (_, i) => i + 1);

// Currency options
export const currencyOptions = [
  { value: 'EUR', label: 'blueprints:wizard.fields.currency.options.eur' },
  { value: 'GBP', label: 'blueprints:wizard.fields.currency.options.gbp' },
  { value: 'USD', label: 'blueprints:wizard.fields.currency.options.usd' },
];

// Conventional genset validation factor
// This factor determines the minimum required genset capacity:
// totalGensetKva >= factor × maxPowerPeak
// Default: 1.0 (100% of peak power required)
// Can be adjusted (e.g., 1.1 = 110% of peak power required)
// Tweakability was a requirement here https://gitlab.com/groups/greenerpowersolutions/-/epics/178 in the section "Conventional genset selection rules"
export const conventionalGensetFactor = 1.0;
